// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  ScoreCard,GameTypeTab,StatsGraph
}                         from '../../../components';

import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';

class PartnerDashboard extends PureComponent {
  static propTypes = {
    earningGraphLabels:   PropTypes.array,
    revenueChart:  PropTypes.shape({
      headers: PropTypes.array,
      data: PropTypes.array
    }),
    earningGraphDatasets: PropTypes.array,
    teamMatesIsFetching:  PropTypes.bool,
    teamMates:            PropTypes.arrayOf(
      PropTypes.shape({
        picture:      PropTypes.string,
        firstname:    PropTypes.string,
        lastname:     PropTypes.string,
        profile:      PropTypes.string,
        profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
      })
    ),
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  state = {
    customer_graph_tabs: [
      {name: 'Data', tablink: '1', isActive: true},    
      {name: 'Customers Trend', tablink: '2', isActive: false},
    ],
    revenue_graph_tabs: [
      {name: 'Data', tablink: '3', isActive: true},    
      {name: 'Revenue Trend', tablink: '4', isActive: false},
    ]    
  };   

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerDashboard');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;
    $('.customer-trend').find("a").trigger("click");
    $('.revenue-trend').find("a").trigger("click");
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerDashboard');
  }

  render() {
    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    return(
      <div>
        <div className="row">
          <ScoreCard name="dashboard_score_card" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>
        </div>
        
        <div className="row">
          <div className="col-md-6">
            <StatsTable bigTable={false} name="hot_leads_last_30_days" displayName="Hot Leads" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>

          <div className="col-md-6">
            <StatsTable bigTable={false} name="pending_renewals_last_30_days" displayName="Renewals" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
        </div>

        {/*<div className="row">
                  <div className="col-md-12">
                    <GameTypeTab bigTable={true} name="paypergame_summary" displayName="Pay per Game Summary" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                  </div>
                </div> */}

        <div className="row">
          <div className="col-md-6 customer-trend">
            <TabPanel>
              <TabPanelHeader tabItems={this.state.customer_graph_tabs}/>
              <TabPanelBody>
                <TabPanelBodyContent id="1">
                    <StatsTable name="active_customers_per_month_graph" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                </TabPanelBodyContent>
                <TabPanelBodyContent id="2">
                  <StatsGraph type="line" name="active_customers_per_month_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                </TabPanelBodyContent>
              </TabPanelBody>
            </TabPanel> 
          </div>
          <div className="col-md-6 revenue-trend">
            <TabPanel>
              <TabPanelHeader tabItems={this.state.revenue_graph_tabs}/>
              <TabPanelBody>
                <TabPanelBodyContent id="3">
                    <StatsTable name="revenue_per_month_by_program_graph" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                </TabPanelBodyContent>
                <TabPanelBodyContent id="4">
                  <StatsGraph type="line" name="revenue_per_month_by_program_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                </TabPanelBodyContent>
              </TabPanelBody>
            </TabPanel> 
          </div>                            
        </div>
        <div className="row">
          <StatsTable bigTable={true} name="collection_this_month" displayName="Collections this Month" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
         <div className="row">
          <StatsTable bigTable={true} name="revenue_target_this_month" displayName="Revenue this Month" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row">
          <StatsTable bigTable={true} name="partner_demo_scheduled" displayName="Demos Scheduled" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
         
        {/*<div className="row">
          <StatsTable bigTable={true} name="partner_collection_per_day" displayName="Collection Per Day" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>*/}

        <div className="row">
          <div className="col-md-12">
            <GameTypeTab name="cohort" displayName="Customer Retention" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
        </div>        

        <div className="row">
          <StatsTable bigTable={true} name="partner_revenue_per_month_by_program" displayName="Revenue Per Month" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>

        {/*<div className="row">
          <StatsTable bigTable={true} name="daily_revenue_by_game_type" displayName="Revenue Per Day" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>*/}

       {/* <div className="row">
          <StatsTable bigTable={true} name="capacity_to_actuals" displayName="Capacity Utilization" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>*/}

       <div className="row">
          <StatsTable bigTable={true} name="active_custombers_by_venue_by_program" displayName="Active Customers this Month" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>

        </div>   
         <div className="row">
          <StatsTable bigTable={true} name="active_customers_today" displayName="Active Customers Today" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>

        </div>  
        <div className="row">
          <div className="col-md-6">
            <StatsTable bigTable={false} name="football_votein" displayName="Football Vote-In" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>

          <div className="col-md-6">
            <StatsTable bigTable={false} name="badminton_votein" displayName="Badminton Vote-In" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
        </div>      

      </div>
    );
  }
}

export default PartnerDashboard;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerDashboard/PartnerDashboard.js